import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITEM_TIMES } from '../actionTypes/actionTypes';
import { IControlTimeRequest, IRootStateLine } from '../model/store.model';

const initialState: IRootStateLine = {
    roaming: [],
    blockedNumberSpecials: [],
    dataShared: [],
};

const linesSlice = createSlice({
    name: ITEM_TIMES,
    initialState,
    reducers: {
        updateLines: (state, action: PayloadAction<IRootStateLine>) => {
            const { payload } = action;
            state.blockedNumberSpecials = [...state.blockedNumberSpecials, ...payload.blockedNumberSpecials];
            state.roaming = [...state.roaming, ...payload.roaming];
        },
        udpateDataShared: (state, action: PayloadAction<IControlTimeRequest>) => {
            const { payload } = action;
            state.dataShared?.push(payload);
        },
        resetLines: (state) => {
            state.blockedNumberSpecials = [];
            state.roaming = [];
        },
    },
});

export const { updateLines, resetLines, udpateDataShared } = linesSlice.actions;
export default linesSlice.reducer;
